<template>
<div id="app" class="privacy-policy page-template-default page page-id-3 wp-custom-logo wp-embed-responsive post-image-aligned-center sticky-menu-fade sticky-enabled both-sticky-menu no-sidebar nav-below-header separate-containers header-aligned-left dropdown-hover">
  <HeadNav selectedLanguage="en" page="privacy" :gotodownload="gotodownload"
      :apk="apk"/>

  <div id="page" class="site grid-container container hfeed">
    <div id="content" class="site-content">
      <div id="primary" class="content-area">
        <main id="maincontent" class="site-main">
          <article id="post-3" class="post-3 page type-page status-publish">
            <div class="inside-article">
              <Breadcrumbs class="privacy-crumb" :items="crumbs" />
              <header class="entry-header section-content" aria-label="Content">
                <h1 class="entry-title" itemprop="headline">
                  Privacy Policy
                </h1>
                <span><strong>Effective Date: </strong>April 9, 2026</span>

              </header>

              <div class="section-content" itemprop="text">
                <p>
                  Your privacy is important to us. This Privacy Policy explains how we collect, use, and protect your information when you visit our website gbofficial.net.
                </p>
                <p>
                  For product education, visit the <router-link to="/">homepage</router-link> and
                  <router-link to="/download/">download section</router-link> first.
                  Deeper reads live in <router-link to="/guides/">guides</router-link>,
                  <router-link to="/comparison/">comparison</router-link>, and the
                  <router-link to="/features/">features hub</router-link>.
                </p>
                
                <h2>Information We Collect</h2>
                <p>
                  We may collect non-personal information such as browser type, device type, and pages visited to improve user experience.
                </p>
                <p>
                  If you contact us via email, we may store your email address to respond to inquiries.
                </p>

                <h2>How We Use Information</h2>
                <ul>
                  <li>To provide and improve our content.</li>
                  <li>To respond to user questions or feedback.</li>
                </ul>

                <h2>Cookies</h2>
                <p>
                  We may use cookies to personalize your experience and analyze site traffic.
                </p>
                <p>
                  You can disable cookies in your browser settings at any time.
                </p>

                <h2>Third-Party Links</h2>
                <p>
                  Our site may contain links to third-party websites. We are not responsible for the privacy practices of these websites.
                </p>

                <h2>Data Security</h2>
                <p>
                  We take reasonable steps to protect your information, but no method of transmission or storage is 100% secure.
                </p>

                <h2>Changes to This Policy</h2>
                <p>
                  We may update this policy from time to time. Any changes will be posted on this page.
                </p>
              </div>

              <div style="height: 20px" aria-hidden="true" class="wp-block-spacer" />
            </div>
          </article>
        </main>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import HeadNav from '@/components/HeadNav.vue';
import Breadcrumbs from '@/components/Breadcrumbs.vue';

export default {
  name: 'Privacy',
  components: {
    HeadNav,
    Breadcrumbs,
  },
  data() {
    return {
      pageName: 'privacy',
      crumbs: [
        { label: 'Home', to: '/' },
        { label: 'Privacy', to: '' },
      ],

      showapk: false,
      apk: null,
      from: 'gb',
      filename: 'gb',
    };
  },
  
  mounted() {
    this.from = this.$global.GetQueryString('from') || this.from;
    this.filename = this.$global.GetQueryString('filename') || this.filename;
    console.log(this.$global.GetQueryString('from'));
    if (this.$global.GetQueryString('from')) {
      this.getAPK();
    } else {
      this.getOfficalApk();
    }
  },
  methods: {
    
    downloadfrom(reason) {
      this.download();
      this.$logEvent(`download_from_${reason}`, 'download');
      // window.location.href = `https://gbapp.pro?apps=gb&domain=gbwhatsapp.chat&appName=GB_gbwhatsapp.chat`;
    },
    getAPK() {
      this.$server
        .getAPPInfo({
          promotionChannel: this.from,
          promotionName: this.filename,
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.apk = res.data.apk;
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    getOfficalApk(type = 1, domain = null, appname = null) {
      this.$server
        .getOfficalApk({
          domain: domain || 'gbwhatsapp.chat',
          appName: appname || 'GB_gbwhatsapp.chat',
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            if (type == 1) {
              this.apk = res.data.apk;
            }
            this.lastupdate = res.data.promotion.updateTime;
            this.votes = res.data.promotion.totalCount;
            this.rating = res.data.promotion.score;
            console.log('apk getted');
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    gotodownload() {
      console.log(this.apk);
      // this.showapk = true
      if (this.apk) {
        this.$global.download(this.apk);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
h2 {
  margin-top: 20px !important;
}

.section-content {
  margin-top: 0;
  margin-bottom: 15px;
}

#maincontent {
  margin-top: 22px !important;
}
</style>
